// extracted by mini-css-extract-plugin
module.exports = {"mint":"MintContainer_mint__20Sk2","mint_area":"MintContainer_mint_area__3FSCj"};